import { useEffect, useState } from "react"
import type { Employee } from "../../Objects/Employee/Employee"
import type { SignUp } from "../../Objects/SignUp/SignUp"
import { normalizePhoneDigits } from "../../utils/phoneFormat"

export interface CompleteOwnerProfileDto {
  name: string
  phoneNumber: string
  companyName: string | null
}

export const useCreateOwnerProfile = (open: boolean, signUp: SignUp, userEmployee: Employee | null) => {
  const [name, setName] = useState("")

  const [phoneNumber, setPhoneNumber] = useState("")

  const [companyName, setCompanyName] = useState("")

  useEffect(() => {
    if (!open) return

    setName(signUp.name.trim() || userEmployee?.personEntity.name?.trim() || "")
    
setPhoneNumber(normalizePhoneDigits(signUp.ownerPhone || userEmployee?.personEntity.phone || ""))

    setCompanyName("")
  }, [open, signUp.name, signUp.ownerPhone, userEmployee?.personEntity.name, userEmployee?.personEntity.phone])

  const handleSubmitForm = (): CompleteOwnerProfileDto => ({
    name: name.trim(),
    phoneNumber,
    companyName: companyName.trim() || null,
  })

  return {
    name,
    phoneNumber,
    companyName,
    setName,
    setPhoneNumber,
    setCompanyName,
    handleSubmitForm,
  }
}
